import { CARD_ERROR_TYPE } from '@linqpal/models/src/dictionaries'
import { Dispatch, SetStateAction } from 'react'
import { ErrorTypes } from '.'

export const errorHandling = (
  t,
  setError: Dispatch<SetStateAction<ErrorTypes>>,
  err,
  setCardFlowCurrent,
) => {
  const errorType = err.type

  let errorMsg1 = t('AddCard.network-error')
  let errorMsg2 = t('AddCard.network-error-msg')
  let errorAction: (() => void) | undefined
  let errorTypeValue = CARD_ERROR_TYPE.NETWORK_ERROR

  console.log('here errorHandling resp data', err)
  console.log('here errorType', errorType)

  switch (errorType) {
    case CARD_ERROR_TYPE.INVALID_CARD_FOR_PULLS:
      errorMsg1 = t('AddCard.invalid-card')
      errorMsg2 = t('AddCard.invalid-card-for-pulls-msg')
      errorTypeValue = CARD_ERROR_TYPE.INVALID_CARD
      break

    case CARD_ERROR_TYPE.INVALID_CARD:
      errorMsg1 = t('AddCard.invalid-card')
      errorMsg2 = t('AddCard.invalid-card-msg')
      errorTypeValue = CARD_ERROR_TYPE.INVALID_CARD
      break

    case CARD_ERROR_TYPE.INVALID_CARD_NUMBER:
      errorMsg1 = t('AddCard.invalid-card-number')
      errorMsg2 = t('AddCard.invalid-card-number-msg')
      errorTypeValue = CARD_ERROR_TYPE.INVALID_CARD_NUMBER
      break

    case CARD_ERROR_TYPE.EXPIRED_CARD:
      errorMsg1 = t('AddCard.expired-card')
      errorMsg2 = t('AddCard.expired-card-msg')
      errorTypeValue = CARD_ERROR_TYPE.EXPIRED_CARD
      break

    case CARD_ERROR_TYPE.CVV_ERROR:
      errorMsg1 = t('AddCard.invalid-security-code')
      errorMsg2 = t('AddCard.invalid-security-code-msg')
      errorTypeValue = CARD_ERROR_TYPE.CVV_ERROR
      break
    case CARD_ERROR_TYPE.ADDRESS_MISMATCH:
      errorMsg1 = t('AddCard.invalid-address')
      errorMsg2 = t('AddCard.invalid-address-msg')
      errorTypeValue = errorType
      errorAction = () => {
        setCardFlowCurrent('AddressDetails')
        setError({
          msg1: '',
          msg2: '',
          type: '',
        })
      }
      break

    case CARD_ERROR_TYPE.INVALID_ADDRESS:
      errorMsg1 = t('AddCard.invalid-address')
      errorMsg2 = t('AddCard.invalid-address-msg')
      errorTypeValue = errorType
      errorAction = () => {
        setCardFlowCurrent('AddressDetails')
        setError({
          msg1: '',
          msg2: '',
          type: '',
        })
      }
      break

    case CARD_ERROR_TYPE.MISSING_ADDRESS_LINE1:
      errorMsg1 = t('AddCard.missing-address-line1')
      errorMsg2 = t('AddCard.missing-address-line1-msg')
      errorTypeValue = errorType
      errorAction = () => {
        setCardFlowCurrent('AddressDetails')
        setError({
          msg1: '',
          msg2: '',
          type: '',
        })
      }
      break

    case CARD_ERROR_TYPE.INVALID_ZIPCODE:
      errorMsg1 = t('AddCard.invalid-zipcode')
      errorMsg2 = t('AddCard.invalid-zipcode-msg')
      errorTypeValue = errorType
      errorAction = () => {
        setCardFlowCurrent('AddressDetails')
        setError({
          msg1: '',
          msg2: '',
          type: '',
        })
      }
      break

    case CARD_ERROR_TYPE.ADDRESS_VERIFICATION_ERROR:
      errorMsg1 = t('AddCard.address-verification-error')
      errorMsg2 = t('AddCard.address-verification-error-msg')
      errorTypeValue = errorType
      break

    case CARD_ERROR_TYPE.DECLINED_CARD:
      errorMsg1 = t('AddCard.card-declined')
      errorMsg2 = t('AddCard.card-declined-msg')
      errorTypeValue = CARD_ERROR_TYPE.DECLINED_CARD
      break

    case CARD_ERROR_TYPE.STOLEN_CARD:
      errorMsg1 = t('AddCard.card-declined')
      errorMsg2 = t('AddCard.stolen-card-msg')
      errorTypeValue = CARD_ERROR_TYPE.STOLEN_CARD
      break

    case CARD_ERROR_TYPE.SECURITY_VIOLATION:
      errorMsg1 = t('AddCard.card-declined')
      errorMsg2 = t('AddCard.security-violation-msg')
      errorTypeValue = CARD_ERROR_TYPE.SECURITY_VIOLATION
      break

    case CARD_ERROR_TYPE.INVALID_CARD_DATE:
      errorMsg1 = t('AddCard.expired-card')
      errorMsg2 = t('AddCard.expired-card-msg')
      errorTypeValue = CARD_ERROR_TYPE.EXPIRED_CARD
      break

    case CARD_ERROR_TYPE.INVALID_CARD_CVV:
      errorMsg1 = t('AddCard.invalid-security-code')
      errorMsg2 = t('AddCard.invalid-security-code-msg')
      errorTypeValue = CARD_ERROR_TYPE.CVV_ERROR
      break

    case CARD_ERROR_TYPE.INSUFFICIENT_FUNDS:
      errorMsg1 = t('AddCard.insufficient-funds')
      errorMsg2 = t('AddCard.insufficient-funds-msg')
      errorTypeValue = CARD_ERROR_TYPE.INSUFFICIENT_FUNDS
      break

    case CARD_ERROR_TYPE.LIMIT_EXCEEDED:
    case CARD_ERROR_TYPE.FREQUENCY_LIMIT:
      errorMsg1 = t('AddCard.limit-exceeded')
      errorMsg2 = t('AddCard.limit-exceeded-msg')
      errorTypeValue = errorType
      break

    case CARD_ERROR_TYPE.INVALID_TRANSACTION:
    case CARD_ERROR_TYPE.TRANSACTION_NOT_PERMITTED:
      errorMsg1 = t('AddCard.transaction-not-permitted')
      errorMsg2 = t('AddCard.transaction-not-permitted-msg')
      errorTypeValue = errorType
      break

    case CARD_ERROR_TYPE.DUPLICATE_TRANSACTION:
      errorMsg1 = t('AddCard.duplicate-transaction')
      errorMsg2 = t('AddCard.duplicate-transaction-msg')
      errorTypeValue = CARD_ERROR_TYPE.DUPLICATE_TRANSACTION
      break

    case 'restricted_card':
      errorMsg1 = t('AddCard.card-declined')
      errorMsg2 = t('AddCard.transaction-not-permitted-msg')
      errorTypeValue = CARD_ERROR_TYPE.TRANSACTION_NOT_PERMITTED
      break

    default:
      break
  }

  setError({
    msg1: errorMsg1,
    msg2: errorMsg2,
    type: errorTypeValue,
    action: errorAction,
  })
}
